var React = require('react');

var AppActions = require('./AppActions.js');

var classMap =
{
  Feed : require('./feed.js'),
  Login : require('./Login.js'),
  Settings : require('./Settings.js'),
  AddCredit : require('./AddCredit.js'),
  TransactionHistory : require('./TransactionHistory.js'),
  UseCredit : require('./UseCredit.js'),
  Rewards : require('./Rewards.js'),
  UseReward : require('./UseReward.js'),
  Promotions : require('./Promotions.js'),
  Locations : require('./Locations.js'),
  CreateUser : require('./CreateUser.js'),
  SendCredit : require('./SendCredit.js'),
  SendGiftCard : require('./SendGiftCard.js'),
  AbsorbGiftCard : require('./AbsorbGiftCard.js'),
  PaymentTypes : require('./PaymentTypes.js'),
  Gifts : require('./Gifts.js'),
  DomainLogin : require('./DomainLogin.js'),
  CheckIn : require('./CheckIn.js'),
  EarnPoints : require('./EarnPoints.js'),
  TransactionScan : require('./TransactionScan.js'),
  CreditInput : require('./CreditInput.js'),
  RewardVerify : require('./RewardVerify.js'),
  CheckInInput : require('./CheckInInput.js'),
  TransactionResult : require('./TransactionResult.js'),
  GiftCardAddCredit : require('./GiftCardAddCredit.js'),
  GiftCardOptions : require('./GiftCardOptions.js'),
  GiftCardUseReward : require('./GiftCardUseReward.js'),
  Instagram : require('./Instagram.js'),
  Facebook : require('./Facebook.js'),
  Twitter : require('./Twitter.js'),
  ExternalLink : require('./ExternalLink.js'),
  Grabb : require('./OrderAhead.js'),//require('./Grabb.js'),
  Tutorial : require('./Tutorial.js'),
  Booking : require('./Booking.js'),
  Passes : require('./Passes.js'),
  AddPass : require('./AddPass.js'),
  UsePass : require('./UsePass.js'),
  Auphan : require('./OrderAhead.js'),//require('./Auphan.js'),
  Refunds : require('./Refunds.js'),
  FeedPlus : require('./FeedPlus.js'),
  EarnPay : require('./EarnPay.js'),
  RewardsCampaigns : require('./RewardsCampaigns.js'),
  ReferAFriend : require('./ReferAFriend.js'),
  PhoneNumberVerify : require('./PhoneNumberVerify.js'),
  PhoneLoyaltyInput : require('./PhoneLoyaltyInput.js'),
  OrderAhead : require('./OrderAhead.js'),
  Birthday : require('./Birthday.js'),
  PassHome : require('./PassHome.js'),
  PhoneLoyaltyInput : require('./PhoneLoyaltyInput.js'),
  MyCard : require('./MyCard.js'),
  SimpleSettings : require('./SimpleSettings.js'),
  SimpleCreateUser : require('./SimpleCreateUser.js'),
  SimpleLogin : require('./SimpleLogin.js'),
  BasicHome : require('./BasicHome.js'),
  SimpleCFD : require('./SimpleCFD.js'),
  TermsPreferences : require('./TermsPreferences.js'),
  ProHome : require('./ProHome.js'),
};

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton
} = MK;

var globalSpace = this;

var AnalyticsManager = require('./AnalyticsManager');

module.exports =
{
  _lastFeatureKeyBuilt : "",
  featureForData : function (featureData, initialLayout, appManager, extras)
  {
    if( featureData.data.name != this._lastFeatureKeyBuilt ) AnalyticsManager.logFeature(featureData.data.title, featureData.data.name);

    this._lastFeatureKeyBuilt = featureData.data.name;
    var key = featureData.key.split("-")[0];
    if( key == "Feed" || key == "FeedPlus" || key == "PassHome" )
    {
      var feedFeatureNames = appManager.getFeedFeatureNames();
      var {dataDependencies, customDependencies, customDependencyKeys} = this.dataDependencies(feedFeatureNames);
      var ThisClass = classMap[key];
      var allDependencyKeys = [];
      if( dataDependencies !== 'undefined' )
      {
        for( var i = 0; i < dataDependencies.length; i++ )
        {
          allDependencyKeys.push(dataDependencies[i]);
        }
      }
      if( typeof customDependencyKeys !== 'undefined' )
      {
        for( var i = 0; i < customDependencyKeys.length; i++ )
        {
          allDependencyKeys.push(customDependencyKeys[i]);
        }
      }

      return (
        <ThisClass
          key={key}
          name={featureData.data.title}
          initialLayout={initialLayout}
          featureData={featureData.data}
          extras={extras}
          appManager={appManager}
          appActions={AppActions}
          dataDependencies={dataDependencies}
          getCards={this.getCards}
          dataDependencyRetriever={this.dataDependencies}
          customDependencies={customDependencies}
          allDependencyKeys={allDependencyKeys}
          featureBuilder={this}
          />
        )
    }
    if( typeof classMap[key] !== 'undefined' )
    {
      var ThisClass = classMap[key];
      var allDependencyKeys = [];
      for( var i = 0; i < ThisClass.dataDependencies.length; i++ )
      {
        allDependencyKeys.push(ThisClass.dataDependencies[i]);
      }
      if( typeof ThisClass.customDependencyKeys !== 'undefined' )
      {
        for( var i = 0; i < ThisClass.customDependencyKeys.length; i++ )
        {
          allDependencyKeys.push(ThisClass.customDependencyKeys[i]);
        }
      }
      return (
        <ThisClass
          key={key}
          name={featureData.data.title}
          initialLayout={initialLayout}
          featureData={featureData.data}
          extras={extras}
          appManager={appManager}
          appActions={AppActions}
          dataDependencies={ThisClass.dataDependencies}
          customDependencies={typeof ThisClass.customDataDependency !== 'undefined' ? [ThisClass.customDataDependency] : []}
          allDependencyKeys={allDependencyKeys}
          featureBuilder={this}
        />
      )
    }
  },

  backOverrideForFeatureData : function(featureData)
  {
    var key = featureData.key.split("-")[0];
    if( typeof classMap[key] !== 'undefined' )
    {
      var ThisClass = classMap[key];
      if( typeof ThisClass.backOverride !== 'undefined' )
      {
        return ThisClass.backOverride;
      }
    }
    return null;
  },

  dataDependencies : function(featureNames)
  {
    var reupDataDependencies = [];
    var customDataDependencies = [];
    var customDependencyKeys = [];
    for( var i = 0; i < featureNames.length; i++ )
    {
      var featureName = featureNames[i];
      if( typeof classMap[featureName] !== 'undefined' )
      {
        var ThisClass = classMap[featureName];
        if( typeof ThisClass.dataDependencies !== 'undefined' )
        {
          var theseDependencies = ThisClass.dataDependencies;
          for( var thisDependencyKey in theseDependencies )
          {
            var thisDependency = theseDependencies[thisDependencyKey];
            var alreadyHadDependency = false;
            for( var dataDependencyKey in reupDataDependencies )
            {
              var dataDependency = reupDataDependencies[dataDependencyKey];
              if( thisDependency == dataDependency )
              {
                alreadyHadDependency = true;
                break;
              }
            }
            if( !alreadyHadDependency ) reupDataDependencies.push(thisDependency);
          }

          if( typeof ThisClass.customDataDependency !== 'undefined' )
          {
            customDataDependencies.push(ThisClass.customDataDependency);
          }

          if( typeof ThisClass.customDependencyKeys !== 'undefined' )
          {
            for( var j = 0; j < ThisClass.customDependencyKeys.length; j++ )
            {
              customDependencyKeys.push(ThisClass.customDependencyKeys[j]);
            }
          }
        }
      }
    }

    return {customDependencies:customDataDependencies, dataDependencies:reupDataDependencies, customDependencyKeys:customDependencyKeys};
  },

  getCards: function(featureNames, appManager, appActions, data, feedFeatures)
  {
    var cards = [];

    if( typeof feedFeatures === 'undefined' && typeof appManager !== 'undefined' ) feedFeatures = appManager.getFeedFeatures();

    // ensure objects are sorted
    if( typeof data.Transactions !== 'undefined' && data.Transactions != null )
    {
      data.Transactions = data.Transactions.sort(function(a,b)
      {
        return appManager.getTime(a.Timestamp) - appManager.getTime(b.Timestamp);
      })
    }
    if( typeof data.Rewards !== 'undefined' && data.Rewards != null )
    {
      data.Rewards = data.Rewards.sort(function(a,b)
      {
        return a.Cost - b.Cost
      })
    }

    for( var i = 0; i < featureNames.length; i++ )
    {
      var featureName = featureNames[i];
      var FeatureClass = classMap[featureName.split('-')[0]];
      if( typeof FeatureClass !== 'undefined' && typeof FeatureClass.getCards !== 'undefined' )
      {
        var featureData = appManager.getFeatureForName(featureName);
        try {
          var theseCards = FeatureClass.getCards(featureData, appActions, typeof data === 'undefined' ? {} : data);
          for( var j = 0; j < theseCards.length; j++ )
          {
            var thisCard = theseCards[j];
            thisCard.key = featureName + j;
            cards.push(thisCard);
          }
        } catch (e) {
          console.log("Failed to get cards for " + featureName,e);
        } finally {

        }
      }
    }

    return cards.sort(function(a,b)
    {
      return a.sortOrder - b.sortOrder;
    });
  },

  featureCustomNavigation: function(featureData, appActions, layout, extras)
  {
    var key = featureData.key.split("-")[0];
    var ThisClass = classMap[key]
    if( typeof ThisClass !== 'undefined' && typeof ThisClass.customNavigation !== 'undefined' )
    {
      ThisClass.customNavigation(featureData, appActions, this, layout, extras);
      return true;
    }
    return false;
  }
}
